<template>
  <div>
    <section class="search-form">
      <el-form
        inline
        :model="originData"
        ref="searchForm"
      >
        <el-form-item
          label="机构代码"
          prop="orgnCode"
        >
          <el-input
            placeholder="请输入"
            v-model="originData.orgnCode"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="机构名称"
          prop="orgnName"
        >
          <el-input
            placeholder="请输入"
            v-model="originData.orgnName"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="IP地址"
          prop="ftpServerIp"
        >
          <el-input
            placeholder="请输入"
            v-model="originData.ftpServerIp"
            oninput="value=value.replace(/[^0-9.]/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="状态"
          prop="status"
        >
          <el-select
            clearable
            v-model="originData.status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </section>
    <div class="flex-between">
      <div>
        <el-button
          size="small"
          type="primary"
          @click="query"
        >查询</el-button>
        <el-button
          size="small"
          @click="onResetClick"
        >清空查询条件</el-button>
      </div>
      <div>
        <el-button
          size="small"
          v-if="functionList.indexOf('336029197918769152')!='-1'"
          @click="addDialog = true"
        >新增双录参数</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
    >
      <el-table-column
        prop="orgnCode"
        width="150"
        label="机构代码"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orgnName"
        width="130"
        label="机构名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ftpServerIp"
        width="200"
        label="FTP服务器IP地址"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ftpServerPort"
        width="100"
        label="端口"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ftpPath"
        label="FTP路径"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ftpUsername"
        label="FTP用户名"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        label="状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status === '1'">启用</span>
          <span v-else>禁用</span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="200"
        align="center"
      >
        <template slot-scope="scope">{{scope.row.createTime|formatTime}}</template>
      </el-table-column>
      <el-table-column
        prop="createUserId"
        label="创建人ID"
        width="260"
        align="center"
      ></el-table-column>
      <el-table-column
        label="修改时间"
        width="200"
        align="center"
      >
        <template slot-scope="scope">{{scope.row.updateTime|formatTime}}</template>
      </el-table-column>
      <el-table-column
        prop="updateUserId"
        label="修改人ID"
        width="260"
        align="center"
      ></el-table-column>
      <el-table-column
        label="操作"
        width="140"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <div class="feature-container">
            <span
              class="button--blue"
              v-if="functionList.indexOf('336029891610513408')!='-1'"
              @click="onEditClick(scope.row)"
            >修改</span>&nbsp;
            <span
              v-if="scope.row.status === '1'&& functionList.indexOf('336030133164675072')!='-1'"
              class="button--red"
              @click="disableClick(scope.row)"
            >禁用</span>
            <span
              v-else-if="functionList.indexOf('336030133164675072')!='-1'"
              class="button--green"
              @click="enableClick(scope.row)"
            >启用</span>
            &nbsp;
            <span
              class="button--red"
              v-if="functionList.indexOf('336030232628400128')!='-1'"
              @click="onDeleteClick(scope.row)"
            >删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
    <!-- 弹框 -->
    <yh-dialog
      title="新增双录参数"
      class="hide-error"
      :visible.sync="addDialog"
    >
      <el-form
        :model="videoData"
        ref="addForm"
      >
        <el-form-item
          label="机构"
          :rules="[{required: true}]"
          prop="orgnCode"
        >
          <yh-select-tree
            placeholder="请选择"
            :width="320"
            clearable
            :load="listChildOrg"
            :value="videoData.orgnName"
            @change="handleTreeChange"
            node-key="orgnCode"
            :default-expanded-keys="[this.orgCode]"
            :render-content="renderOrgTreeItem"
            accordion
            lazy
          />
        </el-form-item>
        <el-form-item
          label="IP地址"
          :rules="[{required: true}]"
          prop="ftpServerIp"
        >
          <el-input
            v-model="videoData.ftpServerIp"
            placeholder="请输入FTP服务器的IP地址，不超过15个字符"
            maxlength="15"
            @keyup.native="videoData.ftpServerIp=videoData.ftpServerIp.replace(/[^\d^\.]+/g,'')"
          >></el-input>
        </el-form-item>
        <el-form-item
          label="端口"
          :rules="[{required: true}]"
          prop="ftpServerPort"
        >
          <el-input
            v-model="videoData.ftpServerPort"
            placeholder="请输入端口号，不超过5个字符"
            maxlength="5"
            @keyup.native="videoData.ftpServerPort=videoData.ftpServerPort.replace(/[^\d]/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="FTP路径"
          :rules="[{required: true}]"
          prop="ftpPath"
        >
          <el-input
            placeholder="支持字母、数字、“_”，首尾字符必须是“/”"
            maxlength="200"
            v-model="videoData.ftpPath"
            @keyup.native="videoData.ftpPath=videoData.ftpPath.replace(/[^0-9a-zA-Z_/]{1,}/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="FTP用户名"
          :rules="[{required: true}]"
          prop="ftpUsername"
        >
          <el-input
            placeholder="请输入FTP用户名，不超过40个字符"
            maxlength="40"
            v-model="videoData.ftpUsername"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          :rules="[{required: true}]"
          prop="ftpPassword"
        >
          <el-input
            v-model="videoData.ftpPassword"
            placeholder="请输入FTP密码，不超过40个字符"
            maxlength="40"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <yh-button
          type="primary"
          @click="onConfirmClick()"
        >新 增</yh-button>
      </span>
    </yh-dialog>

    <yh-dialog
      title="修改双录参数"
      :visible.sync="editDialog"
    >
      <el-form :model="videoDataUp">
        <el-form-item
          label="机构"
          :rules="[{required: true}]"
        >
          <yh-select-tree
            :width="320"
            clearable
            :load="listChildOrg"
            placeholder="请选择"
            :value="videoDataUp.orgnName"
            @change="handleEditTreeChange"
            node-key="orgnCode"
            :default-expanded-keys="[this.orgCode]"
            :render-content="renderOrgTreeItem"
            accordion
            lazy
          />
        </el-form-item>
        <el-form-item
          label="IP地址"
          :rules="[{required: true}]"
        >
          <el-input
            placeholder="请输入FTP服务器的IP地址，不超过15个字符"
            v-model="videoDataUp.ftpServerIp"
            maxlength="15"
            @keyup.native="videoDataUp.ftpServerIp=videoDataUp.ftpServerIp.replace(/[^\d^\.]+/g,'')"
          >></el-input>
        </el-form-item>
        <el-form-item
          label="端口"
          :rules="[{required: true}]"
        >
          <el-input
            v-model="videoDataUp.ftpServerPort"
            placeholder="请输入端口号，不超过5个字符"
            maxlength="5"
            @keyup.native="videoDataUp.ftpServerPort=videoDataUp.ftpServerPort.replace(/[^\d]/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="FTP路径"
          :rules="[{required: true}]"
        >
          <el-input
            v-model="videoDataUp.ftpPath"
            placeholder="支持字母、数字、“_”，首尾字符必须是“/”"
            maxlength="200"
            @keyup.native="videoDataUp.ftpPath
            =videoDataUp.ftpPath.replace(/[^0-9a-zA-Z_/]{1,}$/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="FTP用户名"
          autocomplete="off"
          :rules="[{required: true}]"
        >
          <el-input
            v-model="videoDataUp.ftpUsername"
            placeholder="请输入FTP用户名，不超过40个字符"
            maxlength="40"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          :rules="[{required: true}]"
        >
          <el-input
            autocomplete="new-password"
            v-model="videoDataUp.ftpPassword"
            placeholder="请输入FTP密码，不超过40个字符"
            maxlength="40"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="onConfirmEditClick()"
        >保 存</el-button>
      </span>
    </yh-dialog>
  </div>
</template>

<script>
import { getFunctionList, pageCount, getPagingData } from '@/mixins';

export default {
  name: 'RecordVideoConfig',
  mixins: [getFunctionList, pageCount, getPagingData],
  data() {
    const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      orgName: sessionData.orgnName,
      orgCode: sessionData.orgnCode,
      emptyText: this.$LS.empty,
      tableLabel: [],
      videoData: {
        orgnName: '',
        orgnCode: '', // 机构号
        status: '', // 状态
        ftpServerIp: '', // ip
        ftpServerPort: '', // 端口
        ftpPath: '', // 路径
        ftpUsername: '', // 用户名
        ftpPassword: '', // 密码
        updateUserId: '', // 创建人
      },
      // 修改回显内容
      videoDataUp: {
        id: '',
        orgnName: '', // 机构名称
        status: '', // 状态
        orgnCode: '', // 机构号
        ftpServerIp: '', // ip地址
        ftpServerPort: '', // 端口
        ftpPath: '', // 路径
        ftpUsername: '', // 用户名
        ftpPassword: '', // 密码
        updateUserId: '', // 修改人id
      },
      statusList: [
        {
          value: '1',
          label: '启用',
        },
        {
          value: '0',
          label: '禁用',
        },
      ],
      statusListUp: [
        {
          value: '1',
          label: '启用',
        },
        {
          value: '0',
          label: '禁用',
        },
      ],
      statusListsave: [
        {
          value: '1',
          label: '启用',
        },
        {
          value: '0',
          label: '禁用',
        },
      ],
      currentPage: 1, // 当前页
      pageSize: 10, // 每页显示记录数
      sumCount: 0, // 总记录数
      tableData: [],
      radio: '',
      addDialog: false,
      editDialog: false,
      isSubmitFlag: false,
      functionList: [],
      originData: {
        status: '',
        orgnName: '',
        orgnCode: '',
        ftpServerIp: '',
      },
      searchParam: {
        status: '',
        orgnName: '',
        orgnCode: '',
        ftpServerIp: '',
      },
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
    addDialog() {
      this.resetAddForm();
      this.videoData.orgnName = '';
      this.videoData.orgnCode = '';
      this.videoData.status = '';
      this.videoData.ftpServerIp = '';
      this.videoData.ftpServerPort = '';
      this.videoData.ftpPath = '';
      this.videoData.ftpUsername = '';
      this.videoData.ftpPassword = '';
      this.videoData.updateUserId = '';
    },
  },
  methods: {
    renderOrgTreeItem(h, { data }) {
      const { name } = data;
      if (name.length > 15) {
        return (
          <el-tooltip placement="right" content={name}>
            <span class="ellipsis">{name}</span>
          </el-tooltip>
        );
      }
      return <span>{name}</span>;
    },
    handleTreeChange(data) {
      this.videoData.orgnName = data.name;
      console.log(this.videoData.orgnName);
      this.videoData.orgnCode = data.orgnCode;
      console.log(this.videoData.orgnCode);
    },
    handleEditTreeChange(data) {
      this.videoDataUp.orgnName = data.name;
      this.videoDataUp.orgnCode = data.orgnCode;
    },
    // 加载机构树子节点
    listChildOrg(node, resolve) {
      if (node.level === 0) {
        return resolve([
          {
            name: this.orgName,
            orgnCode: this.orgCode,
          },
        ]);
      }
      if (node.level > 0) {
        const params = {
          data: {
            orgnCode: node.data.orgnCode,
            orgnInheritSign: this.orgnInheritSign,
          },
        };
        return this.$_post(this.$API.subOrganizationList, params).then((res) => {
          function transformList(list) {
            if (!list || list.length === 0) {
              return [];
            }
            return list.map(item => ({
              name: item.title,
              orgnCode: item.id,
            }));
          }
          resolve(transformList(res.data.info.children));
        });
      }
      return '';
    },
    getStatus(key) {
      const statusMap = {
        0: '禁用',
        1: '启用',
      };
      return statusMap[key.status] || '--';
    },
    query() {
      this.searchParam = { ...this.originData };
      if (this.currentPage === 1) {
        this.getTableData();
      } else {
        this.currentPage = 1;
      }
    },
    // 校验输入的ip是否正确
    checkIp(ip) {
      const regex = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
      return regex.test(ip);
    },
    // 校验输入的端口是否正确
    checkPort(port) {
      const regex = /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/;
      return regex.test(port);
    },
    //
    // 校验FTP路径首字符必须是'/'
    checkPath(path) {
      const regex = /^\/.+\/$/;
      return regex.test(path);
    },
    // 重置
    onResetClick() {
      this.$refs.searchForm.resetFields();
    },

    // 获取表格数据
    getTableData() {
      this.getPagingData(this.$API.recordParamListQuery);
    },
    // 获取当前行的数据
    showRow(row) {
      this.radio = row.id;
      this.videoDataUp = JSON.parse(JSON.stringify(row));
    },
    resetAddForm() {
      if (this.$refs.addForm) {
        this.$refs.addForm.resetFields();
      }
    },
    // 新增提示框
    onConfirmClick() {
      const checkResult = this.checkFormData('videoData');
      if (!checkResult) {
        return;
      }
      this.postConfig();
    },

    // 新增
    postConfig() {
      const createUserid = JSON.parse(sessionStorage.getItem('sessionData'))
        .userId;
      const [orgnName1] = this.videoData.orgnName.split('||');
      const parames = {
        data: {
          orgnCode: this.videoData.orgnCode, // 类型：String  必有字段  备注：组织名称
          orgnName: orgnName1, // 类型：String  必有字段  备注：组织名称
          ftpServerIp: this.videoData.ftpServerIp, // 类型：String  必有字段  备注：FTP服务器ip地址
          ftpServerPort: this.videoData.ftpServerPort, // 类型：String  必有字段  备注：FTP服务器端口号
          ftpPath: this.videoData.ftpPath, // 类型：String  必有字段  备注：FTP路径
          ftpUsername: this.videoData.ftpUsername, // 类型：String  必有字段  备注：ftp用户名
          ftpPassword: this.videoData.ftpPassword, // 类型：String  必有字段  备注：密码
          createUserId: createUserid, // 类型：String  必有字段  备注：创建人工号
        },
      };
      return this.$_post(this.$API.recordParamAdd, parames).then((res) => {
        if (res.errorCode === this.$CODE.existOrgn) {
          this.$message.warning(this.$MSG.M0215);
        } else if (res.errorCode === this.$CODE.success) {
          this.addDialog = false;
          this.$message.success(this.$MSG.M0031);
          this.getTableData();
        } else {
          this.$message.error(this.$MSG.M0030);
        }
        this.isSubmitFlag = false;
      });
    },
    // 修改按钮
    onEditClick(row) {
      this.editDialog = true;
      this.videoDataUp = JSON.parse(JSON.stringify(row));
    },
    // 返回结果是 false 或者是 promise
    checkFormData(name) {
      const rules = [
        {
          prop: 'orgnCode',
          message: this.$MSG.M0214,
        },
        {
          prop: 'ftpServerIp',
          message: this.$MSG.M0216,
          // validations: [
          //   {
          //     validate: v => this.checkIp(v),
          //     // TODO: IP格式错误提示
          //     message: "IP格式不正确"
          //   }
          // ]
        },
        {
          prop: 'ftpServerPort',
          message: this.$MSG.M0217,
          // validations: [
          //   {
          //     validate: v => this.checkPort(v),
          //     // TODO: 端口格式错误提示
          //     message: "端口格式不正确"
          //   }
          // ]
        },
        {
          prop: 'ftpPath',
          message: this.$MSG.M0218,
          validations: [
            {
              validate: v => this.checkPath(v),
              // TODO: ftp路径格式错误提示
              message: 'FTP路径的首尾字符必须是“/”',
            },
          ],
        },
        {
          prop: 'ftpUsername',
          message: this.$MSG.M0219,
        },
        {
          prop: 'ftpPassword',
          message: this.$MSG.M0220,
        },
      ];
      return this.validate(rules, this[name]);
    },
    // 修改行
    onConfirmEditClick() {
      const checkResult = this.checkFormData('videoDataUp');
      if (!checkResult) {
        return;
      }
      const [orgnName1] = this.videoDataUp.orgnName.split('||');
      const params = {
        data: {
          // videoData: this.videoDataUp,
          // updateUserId,

          id: this.videoDataUp.id, // 类型：String  必有字段  备注：主键
          orgnCode: this.videoDataUp.orgnCode, // 类型：String  必有字段  备注：组织代码
          orgnName: orgnName1, // 类型：String  必有字段  备注：组织名称
          ftpServerIp: this.videoDataUp.ftpServerIp, // 类型：String  必有字段  备注：FTP服务器ip地址
          ftpServerPort: this.videoDataUp.ftpServerPort, // 类型：String  必有字段  备注：FTP服务器端口号
          ftpPath: this.videoDataUp.ftpPath, // 类型：String  必有字段  备注：FTP路径
          ftpUsername: this.videoDataUp.ftpUsername, // 类型：String  必有字段  备注：ftp用户名
          ftpPassword: this.videoDataUp.ftpPassword, // 类型：String  必有字段  备注：密码
          updateUserId: this.videoDataUp.updateUserId,
        },
      };
      this.updateConfig(params);
    },
    updateConfig(params) {
      return this.$_post(this.$API.recordParamUpdate, params).then((res) => {
        if (res.errorCode === this.$CODE.existOrgn) {
          this.$message.warning(this.$MSG.M0215);
        } else if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0031);
          this.editDialog = false;
          this.getTableData();
          this.editDialog = false;
        } else {
          this.$message.warning(this.$MSG.M0030);
        }
      });
    },
    // 启用操作
    enableClick(row) {
      this.$confirm('确定要启用该双录参数？', '启用双录参数', {
        confirmButtonText: '启用',
        cancelButtonText: '取消',
        closeOnClickModal: false,
      }).then(() => {
        const parames = {
          data: {
            id: row.id, // id
            status: '1', // 启用状态
            updateUserId: JSON.parse(sessionStorage.getItem('sessionData'))
              .userId, // 修改人ID
          },
        };
        return this.$_post(this.$API.disableService, parames).then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.$message.success(this.$MSG.M0031);
          } else {
            this.$message.error(this.$MSG.M0030);
          }
          this.getTableData();
        });
      });
    },
    // 禁用操作
    disableClick(row) {
      this.$confirm(
        '禁用后，将使用直属父机构的双录参数；若直属父机构无双录参数，则该机构及其子机构的双录视频将无法上传，确定要禁用该双录参数吗？',
        '禁用双录参数',
        {
          confirmButtonText: '禁用',
          cancelButtonText: '取消',
          closeOnClickModal: false,
        },
      ).then(() => {
        const parames = {
          data: {
            id: row.id, // id
            status: '0', // 禁用状态
            updateUserId: JSON.parse(sessionStorage.getItem('sessionData'))
              .userId, // 修改人ID
          },
        };
        return this.$_post(this.$API.disableService, parames).then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.$message.success(this.$MSG.M0031);
          } else {
            this.$message.error(this.$MSG.M0030);
          }
          this.getTableData();
        });
      });
    },
    // 删除操作
    onDeleteClick(row) {
      this.$confirm(
        '删除后，将使用直属父机构的双录参数；若直属父机构无双录参数，则该机构及其子机构的双录视频将无法上传，确定要删除该双录参数吗？',
        '删除双录参数',
        {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          closeOnClickModal: false,
        },
      ).then(() => {
        const parames = {
          data: {
            id: row.id, // id
            status: '0', // 禁用状态
            updateUserId: JSON.parse(sessionStorage.getItem('sessionData'))
              .userId, // 修改人ID
          },
        };
        return this.$_post(this.$API.deleteService, parames).then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.$message.success(this.$MSG.M0031);
          } else {
            this.$message.error(this.$MSG.M0030);
          }
          this.getTableData();
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/button.scss";

.btn_disable {
  margin: 0;
  outline: none;
  border: 0;
  color: #fff;
  font-size: 12px;
  padding: 3px 14px;
  background-color: #a2a7b3;
  height: 24px;
  border-radius: 12px;
  margin-left: 10px;
}
.keepButton {
  text-align: center;
}
/*按钮*/
.actionButton {
  text-align: left;
  margin-top: 10px;
  .actionButtonRightUp {
    position: absolute;
    right: 11%;
  }
  .actionButtonRightDown {
    position: absolute;
    right: 3%;
  }
}
</style>
